import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import localStyles from './style.module.css'
import { useAssetLimitsLogic } from '~hooks/useAssetLimitsLogic'
import { useKycUserInfo, useUserInfo } from '~api'

export interface Props {
    isError?: boolean
}

function Block({ isError }: Props) {
    return (
        <div className={localStyles.blockContainer} data-pointer="buy_widget_preloader">
            <div>
                <div className={localStyles.label}>
                    <Loader stopAnimation={isError} />
                </div>
                <div className={localStyles.input}>
                    <Loader stopAnimation={isError} />
                </div>
            </div>
            <div className={localStyles.name}>
                <Loader borderRadius="xl" width={100} height={32} stopAnimation={isError} />
            </div>
        </div>
    )
}

function Preloader({ isError }: Props) {
    useKycUserInfo()
    useAssetLimitsLogic()
    useUserInfo()

    return (
        <div className={localStyles.wrap}>
            <div className={localStyles.container}>
                <Block isError={isError} />
                <div className={localStyles.switcher} />
                <Block isError={isError} />
            </div>
            <div className={localStyles.text}>
                <Loader />
            </div>
            <div className={localStyles.infoBar}>
                <Loader />
            </div>
        </div>
    )
}

export default Preloader
